import { actionTypes } from '../../../types';

// Action creator for generating OTP request
export const getBrandCampaign = (payload) => ({
    type: actionTypes.GET_BRAND_CAMPAIGN_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const getBrandCampaignSuccess = (payload) => ({
    type: actionTypes.GET_BRAND_CAMPAIGN_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const getBrandCampaignFailure = (payload) => ({
    type: actionTypes.GET_BRAND_CAMPAIGN_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const getBrandCampaignReset = () => ({
    type: actionTypes.GET_BRAND_CAMPAIGN_RESET,
});

// Action creator for resetting all OTP generation reducer
export const getBrandCampaignResetAll = () => ({
    type: actionTypes.GET_BRAND_CAMPAIGN_RESET_ALL,
}); 